module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic.c17d5000.jpg";